import { Box, BoxProps, Spinner, Text } from '@razorpay/blade/components';
import React from 'react';

interface FullScreenLoaderProps {
  /**
   * Accessibility label for the spinner
   * @default "loading"
   */
  accessibilityLabel?: string;
  /**
   * Text to display next to the spinner
   * @default "Loading..."
   */
  loadingText?: string;
  /**
   * Direction of the layout
   * @default "row"
   */
  flexDirection?: 'row' | 'column';
  /**
   * Gap between spinner and text
   * @default "spacing.3"
   */
  gap?: BoxProps['gap'];
  /**
   * Height of the loader container
   * @default "100%"
   */
  height?: BoxProps['height'];
}

export const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({
  accessibilityLabel = 'loading',
  loadingText = 'Loading...',
  flexDirection = 'row',
  gap = 'spacing.3',
  height = '100%',
}) => {
  return (
    <Box
      display="flex"
      flexDirection={flexDirection}
      alignItems="center"
      justifyContent="center"
      height={height}
      gap={gap}>
      <Spinner accessibilityLabel={accessibilityLabel} />
      <Text>{loadingText}</Text>
    </Box>
  );
};
